// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"69e99510","186":"7fc222e9","333":"96e6d24b","344":"46f49209","372":"65461595","496":"3bc864e3","738":"f7ecc7ee","841":"032bde4b","856":"ad033bc0"}[chunkId] + ".chunk.js";
};